module.exports = __webpack_public_path__ + "img/ic_rewards.348f725b.png";